var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTickets(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_357_1955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.57997 7.10919C2.20853 7.10919 2.81134 7.35889 3.2558 7.80334C3.70026 8.2478 3.94995 8.85061 3.94995 9.47917C3.94995 10.1077 3.70026 10.7105 3.2558 11.155C2.81134 11.5995 2.20853 11.8492 1.57997 11.8492V13.4291C1.57997 13.8482 1.74643 14.2501 2.04274 14.5464C2.33904 14.8427 2.74092 15.0091 3.15996 15.0091H15.7999C16.2189 15.0091 16.6208 14.8427 16.9171 14.5464C17.2134 14.2501 17.3798 13.8482 17.3798 13.4291V11.8492C16.7513 11.8492 16.1485 11.5995 15.704 11.155C15.2596 10.7105 15.0099 10.1077 15.0099 9.47917C15.0099 8.85061 15.2596 8.2478 15.704 7.80334C16.1485 7.35889 16.7513 7.10919 17.3798 7.10919V5.52921C17.3798 5.11017 17.2134 4.70829 16.9171 4.41199C16.6208 4.11568 16.2189 3.94922 15.7999 3.94922H3.15996C2.74092 3.94922 2.33904 4.11568 2.04274 4.41199C1.74643 4.70829 1.57997 5.11017 1.57997 5.52921V7.10919Z",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2699 3.94922V5.52921",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2699 13.4287V15.0087",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2699 8.68848V10.2685",
    stroke: "#364153",
    strokeWidth: 1.57999,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_357_1955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.9598,
    height: 18.9598,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickets);
export default __webpack_public_path__ + "static/media/tickets.55e25459d291b9f02439081e88853145.svg";
export { ForwardRef as ReactComponent };